import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ServiceRequestStepType } from "src/app/components/service-request/models/ServiceRequestStepType";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Tool } from "src/app/models/Tool";

@Component({
  selector: "app-service-request-stepper-control",
  templateUrl: "./service-request-stepper-control.component.html",
  standalone: false,
})
export class ServiceRequestStepperControlComponent {
  @Input() disableContinueBtn: boolean;
  @Input() currentStep: ServiceRequestStepType;
  @Input()
  set equipmentList(value: Tool[]) {
    this.createServicesSummary(value);
  }

  @Output() continue = new EventEmitter<ServiceRequestStepType>();
  @Output() stepperClose = new EventEmitter<void>();

  serviceRequestStepType = ServiceRequestStepType;
  localizationConstants = LocalizationConstants;

  servicesSummary: Record<string, Record<string, string[]>>;
  servicesSummaryEquipmentLength: number;

  /**
   * Create dictionary of serialNumbers from basket.tools grouped by requestedService and then by modelNumber
   */
  createServicesSummary(equipmentList: Tool[]) {
    if (!equipmentList?.length) {
      return;
    }

    this.servicesSummaryEquipmentLength = equipmentList.length;
    this.servicesSummary = equipmentList.reduce((acc, curr) => {
      const { requestedService, modelNumber, serialNumber } = curr;
      if (!acc[requestedService]) {
        acc[requestedService] = {};
      }
      if (!acc[requestedService][modelNumber]) {
        acc[requestedService][modelNumber] = [];
      }
      acc[requestedService][modelNumber].push(serialNumber);
      return acc;
    }, {});
  }
}
